import { lazy } from "react";

export const UserPage = lazy(() => import("./userPage"));
